"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rank = void 0;
var Rank;
(function (Rank) {
    Rank[Rank["ACE"] = 0] = "ACE";
    Rank[Rank["TWO"] = 1] = "TWO";
    Rank[Rank["THREE"] = 2] = "THREE";
    Rank[Rank["FOUR"] = 3] = "FOUR";
    Rank[Rank["FIVE"] = 4] = "FIVE";
    Rank[Rank["SIX"] = 5] = "SIX";
    Rank[Rank["SEVEN"] = 6] = "SEVEN";
    Rank[Rank["EIGHT"] = 7] = "EIGHT";
    Rank[Rank["NINE"] = 8] = "NINE";
    Rank[Rank["TEN"] = 9] = "TEN";
    Rank[Rank["JACK"] = 10] = "JACK";
    Rank[Rank["QUEEN"] = 11] = "QUEEN";
    Rank[Rank["KING"] = 12] = "KING";
    Rank[Rank["HIGH_ACE"] = 13] = "HIGH_ACE";
})(Rank || (exports.Rank = Rank = {}));
//# sourceMappingURL=Rank.js.map